<div id="s_one" class="liquid-form-area" style="display: block">
    <div class="liquid-form-logo">
        <a href="#"><img src="assets/images/logo.png" alt="" /></a>
    </div>
    <div class="liquid-form-heading-text">
        <i class="fa fa-circle-o-notch fa-spin" *ngIf="activatingUser"></i>
    </div>
    <div *ngIf="!activatingUser">
        <ng-container
            *ngTemplateOutlet="linkExpired ? expiredLink : success"
        ></ng-container>
    </div>
</div>

<ng-template #success>
    <div class="liquid-form-heading-text">
        <div *ngIf="error">
            <h4 style="color: red">{{ message }}</h4>
        </div>
        <div *ngIf="!error">
            <h4 style="color: #00cc33">User Activated!</h4>
            <p>User activated successfully, you may now sign in</p>
        </div>
    </div>
    <div class="liquid-form-content">
        <div class="liquid-login-form-submit">
            <div id="fast-btn">
                <button [routerLink]="['/auth/login']">SIGN IN</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #expiredLink>
    <div class="liquid-form-heading-text activation-link">
        <h4>Activation Link Expired</h4>
        <p>Please contact an administrator to send you a new one.</p>
    </div>
    <div class="liquid-form-content">
        <div class="liquid-login-form-submit">
            <div id="fast-btn">
                <button [routerLink]="['/auth/login']">SIGN IN</button>
            </div>
        </div>
    </div>
</ng-template>
